module.exports = __webpack_public_path__ + "static/media/ABCUserData.a2d6abbd.xlsx";